import React from 'react';
import styles from './NewsletterCard.module.scss';
import Text from '../text/Text';
import formatDate from '../../../app/helpers/formateDate';
import useIsRtl from '../../../app/helpers/isRtl';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
import { useNavigate } from 'react-router-dom';

const clockSvg = '/assets/svg/cards/clock.svg';
const defaultImage = '/images/defaultImage';

const NewsletterCard = ({ image, title, id }) => {
  const navigate = useNavigate();
  const sanitizedImageUrl = sanitizeAndValidateUrl(image);
  const handleError = (e) => {
    e.target.src = defaultImage;
  };
  const handleNavigate = () => {
    navigate(`/news-and-events/news/newsletter-${id}`);
  };
  return (
    <div className={styles.card} onClick={handleNavigate}>
      <div className={styles.imageWrapper}>
        <img
          src={sanitizedImageUrl || defaultImage}
          alt={title || ''}
          className={styles.image}
          onError={handleError}
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className={styles.content}>
        <div className={styles['title']}>
          <Text
            title={title}
            variant="text-bold-italic-16"
            color="white"
            maxLines={2}
          />
        </div>
      </div>
    </div>
  );
};

export default NewsletterCard;
